"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _SkeletonLoadWrapper = _interopRequireDefault(require("pricing-pages-unified-ui/components/loading/SkeletonLoadWrapper"));

var _colors = require("HubStyleTokens/colors");

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _responsiveBreakpoints = _interopRequireDefault(require("pricing-pages-unified-ui/utils/responsiveBreakpoints"));

var _UICardWrapper = _interopRequireDefault(require("UIComponents/card/UICardWrapper"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _CurrentPlanTag = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/CurrentPlanTag"));

function _templateObject18() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    width: 100%;\n  "]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    width: 50%;\n    margin-left: auto;\n    margin-right: auto;\n  "]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin: 30px 0;\n  width: 90%;\n  text-align: center;\n\n  button,\n  a {\n    width: 100%;\n    line-height: 23px;\n  }\n  ", ";\n  ", ";\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    margin-top: 30px;\n    padding-left: 30px;\n    padding-right: 30px;\n  "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    border-right: none;\n    margin-top: 85px;\n    padding-left: 60px;\n  "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  padding: 0 60px 0 90px;\n  margin: 50px 0 50px 0;\n  border-right: 1px solid ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    width: 100%;\n    text-align: center;\n  "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  color: ", ";\n  width: 300px;\n  display: block;\n  ", ";\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    width: 100%;\n    text-align: center;\n  "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  width: 300px;\n  font-size: 14px;\n  margin-top: 9px;\n  text-align: left;\n  display: block;\n  ", ";\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    text-align: center;\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-size: 32px;\n  font-weight: 600;\n  line-height: 44px;\n  text-align: left;\n  display: block;\n  ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    padding-right: 30px;\n    padding-left: 30px;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    padding-right: 60px;\n    padding-left: 60px;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  height: 100%;\n  text-align: left;\n  padding-right: 30px;\n  padding-left: 30px;\n  ", ";\n  ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    &&& {\n      width: 100%;\n    }\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    min-width: 0;\n    &&& {\n      width: 90%;\n      margin: 0 auto;\n    }\n    > div {\n      flex-direction: column;\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  border: 1px solid ", ";\n  background-color: ", ";\n  min-height: 500px;\n  ", ";\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledCardWrapper = (0, _styledComponents.default)(_UICardWrapper.default).withConfig({
  displayName: "HorizontalMerchCard__StyledCardWrapper",
  componentId: "sc-17n2blq-0"
})(_templateObject(), _colors.BATTLESHIP, _colors.OLAF, _responsiveBreakpoints.default.tablet(_templateObject2()), _responsiveBreakpoints.default.phone(_templateObject3()));
var BizObjectivesSection = (0, _styledComponents.default)(_UIFlex.default).withConfig({
  displayName: "HorizontalMerchCard__BizObjectivesSection",
  componentId: "sc-17n2blq-1"
})(_templateObject4(), _responsiveBreakpoints.default.tablet(_templateObject5()), _responsiveBreakpoints.default.phone(_templateObject6()));

var TitleWrapper = _styledComponents.default.div.withConfig({
  displayName: "HorizontalMerchCard__TitleWrapper",
  componentId: "sc-17n2blq-2"
})(_templateObject7(), _responsiveBreakpoints.default.tablet(_templateObject8()));

var DescriptionWrapper = _styledComponents.default.div.withConfig({
  displayName: "HorizontalMerchCard__DescriptionWrapper",
  componentId: "sc-17n2blq-3"
})(_templateObject9(), _responsiveBreakpoints.default.tablet(_templateObject10()));

var SubtextWrapper = (0, _styledComponents.default)(_Small.default).withConfig({
  displayName: "HorizontalMerchCard__SubtextWrapper",
  componentId: "sc-17n2blq-4"
})(_templateObject11(), _colors.SLINKY, _responsiveBreakpoints.default.tablet(_templateObject12()));

var ProductInfoSection = _styledComponents.default.div.withConfig({
  displayName: "HorizontalMerchCard__ProductInfoSection",
  componentId: "sc-17n2blq-5"
})(_templateObject13(), _colors.GREAT_WHITE, _responsiveBreakpoints.default.tablet(_templateObject14()), _responsiveBreakpoints.default.phone(_templateObject15()));

var StyledCTAsWrapper = _styledComponents.default.div.withConfig({
  displayName: "HorizontalMerchCard__StyledCTAsWrapper",
  componentId: "sc-17n2blq-6"
})(_templateObject16(), _responsiveBreakpoints.default.tablet(_templateObject17()), _responsiveBreakpoints.default.tabletPortrait(_templateObject18()));

var HorizontalMerchCard = function HorizontalMerchCard(_ref) {
  var ProductTitle = _ref.ProductTitle,
      ProductDescription = _ref.ProductDescription,
      SeeAllFeaturesSection = _ref.SeeAllFeaturesSection,
      PriceDisplay = _ref.PriceDisplay,
      BizObjectives = _ref.BizObjectives,
      CTAs = _ref.CTAs,
      hasPricingAndPurchasingSucceeded = _ref.hasPricingAndPurchasingSucceeded,
      ownsProduct = _ref.ownsProduct,
      productIdentifier = _ref.productIdentifier,
      _ref$Subtext = _ref.Subtext,
      Subtext = _ref$Subtext === void 0 ? null : _ref$Subtext;
  return _react.default.createElement(StyledCardWrapper, {
    className: "m-top-10",
    "data-selenium-id": productIdentifier + "-merch-card"
  }, ownsProduct && _react.default.createElement(_CurrentPlanTag.default, null), _react.default.createElement(_UIFlex.default, {
    align: "center",
    justify: "center"
  }, _react.default.createElement(ProductInfoSection, null, _react.default.createElement(TitleWrapper, null, ProductTitle), _react.default.createElement(DescriptionWrapper, null, ProductDescription), _react.default.createElement(_SkeletonLoadWrapper.default, {
    isLoading: !hasPricingAndPurchasingSucceeded,
    widths: [100],
    heights: [27],
    className: 'm-top-5'
  }, PriceDisplay), _react.default.createElement(StyledCTAsWrapper, null, _react.default.createElement(_SkeletonLoadWrapper.default, {
    isLoading: !hasPricingAndPurchasingSucceeded,
    heights: [49]
  }, CTAs)), _react.default.createElement(SubtextWrapper, null, _react.default.createElement(_SkeletonLoadWrapper.default, {
    isLoading: !hasPricingAndPurchasingSucceeded,
    heights: [72]
  }, Subtext))), _react.default.createElement(BizObjectivesSection, {
    direction: "column",
    justify: "center",
    align: "center"
  }, BizObjectives)), SeeAllFeaturesSection);
};

HorizontalMerchCard.propTypes = {
  ProductTitle: _propTypes.default.node.isRequired,
  ProductDescription: _propTypes.default.node.isRequired,
  PriceDisplay: _propTypes.default.node.isRequired,
  BizObjectives: _propTypes.default.node.isRequired,
  productIdentifier: _propTypes.default.string,
  Subtext: _propTypes.default.node,
  CTAs: _propTypes.default.node.isRequired,
  SeeAllFeaturesSection: _propTypes.default.node,
  ownsProduct: _propTypes.default.bool,
  hasPricingAndPurchasingSucceeded: _propTypes.default.bool.isRequired
};
var _default = HorizontalMerchCard;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/product-pages/HorizontalMerchCard.js
// module id = 848
// module chunks = 5 6